import { GameRandom, ModelEvents } from '@denishussar/html5-game-engine';
import { Inject, Singleton } from '@denishussar/html5-game-engine';

export enum ButtonsValueEnum {
    num0 = 1,
    num1 = 2,
    num2 = 3,
    num3 = 'c',
    num4 = 4,
    num5 = 5,
    num6 = 6,
    num7 = 7,
    num8 = 8,
    num9 = 9,
    num10 = '*',
    num11 = 0,
    num12 = '`',
}
export enum RightCodeEnum {
    code0 = '2387',
    code1 = '3458',
    code2 = '4501',
}

export enum CardsColorEnum {
    color0 = 'blue',
    color1 = 'yellow',
    color2 = 'purple',
}

export class ButtonModel {
    public value: ButtonsValueEnum = null;

    constructor(public index: number) {
        this.value = ButtonsValueEnum[`num${index}`];
    }
}

@Singleton
export class BlockCardsModel {
    public buttons = new Array<ButtonModel>();
    public codes = new Array();
    public cards = new Array();
    public doneCodes = new Array();
    public resultCode: string = '';
    public isLockedCard: string = 'active';
    public showHover: string = 'active';

    constructor(
        @Inject private _$random: GameRandom,
        @Inject private _$modelEvents: ModelEvents
    ) {
        for (let i = 0; i < 13; i++) {
            this.buttons.push(new ButtonModel(i));
        }
        for (let i = 0; i < 3; i++) {
            this.codes.push(this._$random.integer(1000, 9999).toString());
        }
    }
}
